/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpsertShiftSchedulesRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {UpsertShiftSchedulesResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const upsertShiftSchedules = (request: UpsertShiftSchedulesRequest, options?: CashRequestOptions) => post<UpsertShiftSchedulesRequest, UpsertShiftSchedulesResponse>("/2.0/cash/upsert-shift-schedules", request, {...options, rejectOnError: true })